import { hasDevisInstallateur, getRegimeAides } from "./tenantProfile";

// Composition des étapes du wizard devis — DÉRIVÉE DES CAPACITÉS DÉCLARÉES du tenant,
// ⛔ jamais d'un slug ni du seul type de client.
//   · Installateur ⇐ `config.devis_installateur_requis`
//   · Aides        ⇐ `config.regime_aides` non vide (mpr / cee / anah)
// Client, Produits et Validation (Enregistrer) sont communes à tous.
//
// DETTE D'ARCHITECTURE (assumée, lot P0 devis Mario) : les identifiants d'étape restent
// les numéros historiques 1..5 ; une étape inactive est retirée de la séquence
// affichée, et sa validation vaut « ok ». Une composition déclarative complète
// (registre d'étapes par capacité) reste à faire.
export const ETAPE_CLIENT = 1;
export const ETAPE_PRODUITS = 2;
export const ETAPE_INSTALLATEUR = 3;
export const ETAPE_AIDES = 4;
export const ETAPE_VALIDATION = 5;

export function composerEtapesDevis({ installateurRequis = false, regimeAides = [] } = {}) {
  const ids = [ETAPE_CLIENT, ETAPE_PRODUITS];
  if (installateurRequis) ids.push(ETAPE_INSTALLATEUR);
  if (Array.isArray(regimeAides) && regimeAides.length > 0) ids.push(ETAPE_AIDES);
  ids.push(ETAPE_VALIDATION);
  return ids;
}

export function etapesDevisDuTenant() {
  return composerEtapesDevis({
    installateurRequis: hasDevisInstallateur(),
    regimeAides: getRegimeAides(),
  });
}

export function etapeApres(ids, courante) {
  const i = ids.indexOf(courante);
  return i >= 0 && i < ids.length - 1 ? ids[i + 1] : null;
}

export function etapeAvant(ids, courante) {
  const i = ids.indexOf(courante);
  return i > 0 ? ids[i - 1] : null;
}

// Saisie décimale d'une ligne de devis — VIRGULE ou POINT (« 12,5 » ≡ « 12.5 »).
// 🔴 Mesuré en Chromium (fr-FR ET en-US) : un `<input type="number">` AVALE la
// virgule — « 12,5 » devenait 125, quantité ×10 sans aucun message. Le champ est
// donc un texte (`inputMode="decimal"`) lu ICI. Espaces (milliers) ignorés.
// Tout le reste (« 12,5,3 », « abc », vide) ⇒ NaN : refusé, ⛔ jamais deviné.
export function lireDecimal(saisie) {
  const t = String(saisie ?? "").replace(/[\s  ]/g, "").replace(",", ".");
  return /^\d+(\.\d+)?$|^\.\d+$/.test(t) ? Number(t) : NaN;
}

// Valeur serveur affichée à la française dans un champ texte (12.5 ⇒ « 12,5 »).
export function afficherDecimal(valeur) {
  return valeur == null || valeur === "" ? "" : String(valeur).replace(".", ",");
}

// Total d'une ligne = quantité × prix unitaire HT (arrondi au centime, comme le serveur).
export function totalLigneHt(quantite, prixUnitaireHt) {
  const q = Number(quantite);
  const pu = Number(prixUnitaireHt);
  if (!Number.isFinite(q) || !Number.isFinite(pu)) return 0;
  return Math.round(q * pu * 100) / 100;
}

// 🔴 N°1002 #8 — CRÉATION vs MODIFICATION du devis. Le wizard ne connaissait QUE la
// création : titre « Création devis » en dur, numéro provisoire affiché même sur un devis
// émis (« DRAFT-00001 » à côté de « Émis »). Un devis ouvert par son id = MODIFICATION.
export function estModificationDevis(devisIdInitial) {
  return Boolean(devisIdInitial) && devisIdInitial !== "new";
}
export function titreDevisWizard(devisIdInitial) {
  return estModificationDevis(devisIdInitial) ? "Modifier le devis" : "Création devis";
}
// Numéro DÉFINITIF dès qu'il existe ; le provisoire seulement pour un brouillon.
export function numeroDevisAffiche(devis) {
  return devis?.numero || devis?.numero_provisoire || "Nouveau";
}
// Étape 1 en modification : formulaire « Informations client » ; le récapitulatif
// fiscal / logement / MPR reste affiché EN DESSOUS pour un tenant qui déclare un
// régime d'aides (Climat, OMV…) — décidé par la CONFIG du tenant, ⛔ jamais par slug.
export function recapAidesEtapeClient(regimeAides) {
  return Array.isArray(regimeAides) && regimeAides.length > 0;
}
